import { Data_getInstance2uoaydfs2alvj as Data_getInstance } from './adapter/DeletePinMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { DeletePinMutationSelections_getInstance3k0bkgck66oid as DeletePinMutationSelections_getInstance } from './selections/DeletePinMutationSelections.mjs';
import { DeletePinMutation_VariablesAdapter_instance7rhnvtqgucyl as DeletePinMutation_VariablesAdapter_instance } from './adapter/DeletePinMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deletePin) {
        this.n6e_1 = deletePin;
      }
      toString() {
        return 'Data(deletePin=' + this.n6e_1 + ')';
      }
      hashCode() {
        return this.n6e_1 == null ? 0 : getBooleanHashCode(this.n6e_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.n6e_1 == other.n6e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.o6e_1 = obj(Data_getInstance());
        this.p6e_1 = (new (Builder())('data', Companion_getInstance().p6d_1)).s43(DeletePinMutationSelections_getInstance().s6e_1).i37();
        this.q6e_1 = '4959d3041a099d0c81ec21b955af64a4289b42092bf6de72160613a29419fd95';
        this.r6e_1 = 'deletePin';
      }
      s6d() {
        return 'mutation deletePin($input: DeletePinInput!) { deletePin(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DeletePinMutationClass;
function DeletePinMutation() {
  if (DeletePinMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.t6e_1 = input;
      }
      u6d() {
        return '4959d3041a099d0c81ec21b955af64a4289b42092bf6de72160613a29419fd95';
      }
      operationId() {
        return this.u6d();
      }
      l47() {
        return Companion_getInstance_0().s6d();
      }
      v6d() {
        return 'deletePin';
      }
      operationName() {
        return this.v6d();
      }
      p46(writer, customScalarAdapters, withDefaultValues) {
        DeletePinMutation_VariablesAdapter_instance.u6e(writer, this, customScalarAdapters, withDefaultValues);
      }
      o46() {
        return Companion_getInstance_0().o6e_1;
      }
      toString() {
        return 'DeletePinMutation(input=' + this.t6e_1.toString() + ')';
      }
      hashCode() {
        return this.t6e_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePinMutation()))
          return false;
        if (!this.t6e_1.equals(other.t6e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePinMutation', VOID, VOID, [Mutation()]);
    DeletePinMutationClass = $;
  }
  return DeletePinMutationClass;
}
//region block: exports
export {
  Data as Data1jasy19j4j968,
  DeletePinMutation as DeletePinMutation2z9xaiydj80c8,
};
//endregion

//# sourceMappingURL=DeletePinMutation.mjs.map
